import React, { Component } from 'react';
import { API_MHS_KRS } from '../../services/key/api';
import { KEY_MHS_KRS } from '../../services/key/api_key';

export default class Loading extends Component {

  loginProcess = async () => {
    const checkId = this.props.location.state;
    if (checkId == undefined) {
      window.location.replace("/loadingout");
    }
    else {
      const now = new Date()
      const id_camaba = this.props.location.state.icmb;
      // expired in 2 hours
      const time = 7200000
      localStorage.setItem('icmb', id_camaba)
      localStorage.setItem('auth_expired_date', now.getTime() + time)
      await API_MHS_KRS.get('core-mhs/biodata/mhs/' + id_camaba + KEY_MHS_KRS).then((res) => {
        localStorage.setItem('nama', res.data.content.nama)
        localStorage.setItem('foto', res.data.content.foto_mhs)
      })
      window.location.replace("/home");
    }
  }

  componentDidMount() {
    this.loginProcess()
  }

  render() {

    return (
      <svg id="darkLoader" className="" width="100%" viewBox="0 0 100 100" style={{ backgroundColor: 'white' }}>
        <circle className="circle" id="circle-1" cx={50} cy={50} r={1000} fill="rgba(167, 206, 232, .25)" />
        <circle className="circle" id="circle-2" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
        <circle className="circle" id="circle-3" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
      </svg>
    )
  }
}
